export class Reparacion {
    idReparacion: number;
    fechaInicio: Date;
    avance: number;
    fechaTermino: Date;
    status: string;
    ordenServicio: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/reparacion.ts